import React, { Component, ReactNode } from 'react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { localeService } from '../../services';
import { Platform, WriteDirection } from 'sofa-reborn-react';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { KompisText, KompisPrompt } from '@inter-ikea-kompis/react-components';

type Props = {
	platform: Platform;
	writeDirection: WriteDirection;
	showUseFromScratchButton: boolean;
	missingArticleDescription: string;
	missingDeeplink: string | null;
	showPrompt: boolean;
	onClick: (event: CustomEvent) => void;
};

/**
 * React component.
 *
 */
export default class MissingArticle extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		const { onClick } = props;
		return (
			<KompisPrompt
				heading={
					props.missingDeeplink
						? localeService.getTranslation('somethingWentWrong')
						: localeService.getTranslation('invalidConfigurationMessage')
				}
				primaryButtonLabel={localeService.getTranslation('startFromScratch')}
				secondaryButtonLabel={
					!props.showUseFromScratchButton
						? localeService.getTranslation('sprValidationUnavailableButtonUseCurrent')
						: localeService.getTranslation('sprValidationUnavailableButtonSelectNew')
				}
				onButtonClick={(event: CustomEvent) => onClick && onClick(event)}
				visible={props.showPrompt}
				theme={SkapaTheme}
				disableIframeSticky={false}
			>
				<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium}>
					{props.missingDeeplink ? null : props.missingArticleDescription}
				</KompisText>
			</KompisPrompt>
		);
	}
}
